import React from 'react'
import {observer, inject} from 'mobx-react'

const Reconnect = ({ translationStore, routingStore }) => {

  const youAreDisconnected = translationStore.translate('you_are_disconected_error')
  const retry = translationStore.translate('retry_connection')

  return (
    <div>
      <p className='mb-8'>{youAreDisconnected }</p>
      <span
        className='cursor-pointer btn-white'
        onClick={() => window.location.reload()}>
         { retry }...
      </span>
    </div>
  )
}

export default inject('translationStore', 'routingStore')(observer(Reconnect))



// WEBPACK FOOTER //
// ./src/components/Reconnect.js